import { render } from "./Main.vue?vue&type=template&id=b568a6f8"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=b568a6f8&lang=css"
script.render = render

export default script